export const translations = {
  nav: {
    aboutUs: "About Us",
    projects: "Projects",
    services: "Services",
    contact: "Contact Us"
  },
  hero: {
    title: "Karya Artistika Nusaindo",
    subtitle: "Transform your dreams into reality!",
    description: "We deliver exceptional work and craftsmanship tailored to your needs, let's build your extraordinary vision into reality together!",
    contactButton: "Contact Us →"
  },
  clients: {
    title: "Our Clients"
  },
  projects: {
    title: "Our Projects",
    description: "We have worked and shown our tireless commitment through our work, our recent projects demonstrate how 5 years of hard work and discipline translate into magnificent results, here are our recent projects!",
    previousProjects: {
      title: "Previous Projects",
      description: "Our portfolio showcases a diverse range of successful projects that highlight our expertise and commitment to excellence. From residential renovations to commercial developments, each project represents our dedication to quality craftsmanship and innovative design solutions."
    },
    viewAll: "View all projects →"
  },
  services: {
    title: "Our Services",
    fitOut: {
      title: "Fit Out (Commercial & Retail Spaces)",
      description: "Transforming empty shells and spaces into functional environments, we specialize in turnkey interior fit outs for malls, offices, and retail spaces."
    },
    interiorDesign: {
      title: "Interior Design",
      description: "Our team creates harmonious, user-centric spaces through 3D visualization, space planning, material curation, furniture coordination, and lighting design."
    },
    construction: {
      title: "General Constructions",
      description: "From commercial buildings, large scale projects, and residential, we build almost anything."
    }
  },
  footer: {
    tagline: "Transform your dreams into reality!"
  },
  aboutUs: {
    companyProfile: {
      title: "Company Profile",
      description: [
        "PT. Karya Artistika Nusaindo is a dynamic, disciplined, and innovative contracting firm specializing in Interior Fit Out, Interior Design, and General Construction Services. Founded in June 2020 by three passionate professionals in Tangerang. Started as a small team that focused solely on Interior Fit Out and limited radius of work range.",
        "Through dedication, quality commitment, and willingness to grow, PT. Karya Artistika Nusaindo have expanded their services to meet the growing demands of clients. Today, PT. Karya Artistika Nusaindo blends creativity, timeless design, and technical precision to deliver more services and end-to-end construction solutions."
      ]
    },
    journey: {
      title: "Our Journey",
      items: [
        {
          year: "2020",
          description: "Founded in Tangerang as a small team that specialized in interior fit out, which focused on local projects with desire to grow and learn."
        },
        {
          year: "2020 - 2023",
          description: "Expanded our services and our team to include interior design and started to take major projects"
        },
        {
          year: "2024 - Present",
          description: "Grow into a full service general construction firm, delivering excellent solutions nationwide, and trusted as a humble yet impactful construction firm"
        }
      ]
    },
    values: {
      title: "Our Values",
      items: [
        {
          title: "Vision",
          points: [
            "To be a trusted leader in construction and design, transforming spaces with innovation, creativity, and reliability."
          ]
        },
        {
          title: "Mission",
          points: [
            "Deliver high-quality constructing solutions",
            "Continuously improve skills and technology to stay ahead in the industry",
            "Foster long term client relationship",
            "Developing innovative designs that balance beauty and functionality",
            "Goal-oriented approach with punctual delivery"
          ]
        }
      ]
    },
    management: {
      title: "Management",
      members: [
        {
          name: "Tazim Samzir",
          position: "President Director",
          description: "With decades of experience and unwavering dedication to the construction industry, he leads the company's strategic vision with integrity, innovation, and a relentless commitment to excellence."
        },
        {
          name: "Andreas Prabowo",
          position: "Director",
          description: "Andreas Prabowo brings a unique blend of artistic vision and technical expertise to PT. Karta Artistika Nusaindo. As Director he oversees the company's creative and operational execution, ensuring that every project and activities harmonizes functionality with aesthetic brilliance."
        },
        {
          name: "Suriyanto",
          position: "Commissioner",
          description: "Provides strategic oversight and governance to ensure the company's long term vision, mission, and values align with the work execution and innovation."
        }
      ]
    },
    contact: {
      title: "Interested in a collaboration?",
      button: "Contact Us →"
    }
  },
  contact: {
    title: "Contact Us",
    formTitle: "Send us a message",
    infoTitle: "Contact Information",
    location: "Our Location",
    name: "Your Name",
    email: "Your Email",
    message: "Your Message",
    sendButton: "Send Message",
    address: "Address",
    phone: "Phone",
    whatsappButton: "Chat on WhatsApp",
    description: "If you have any questions, please feel free to get in touch with us via phone, text, email, the form below or even social media!"
  }
}; 